<template>
  <b-row>
    <b-col md="12" class="text-right">
      <div>Balance: {{balance|currency}}</div>
      <div>Amount: {{total|currency}}</div>
      <span class="text-small text-danger" v-if="total > balance">
        The total for this category cannot exceed the current category balance
      </span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: [
    'balance',
    'total',
  ],
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/estimate_of_repairs/Balance.vue